export default __webpack_public_path__ + "media/images/images/icons/google-0cfdba6858b374e3e129766645d7e1ca.png";